import Swiper from 'swiper';

const swiper = new Swiper('#slider', {
    effect: 'fade',
    loop: false,
    preventClicks: true,
    simulateTouch: false,

    // Pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
    },

    // UI
    grabCursor: false,

    autoplay: {
        delay: 8000,
        disableOnInteraction: true
    },

    // Aria
    a11y: {
        prevSlideMessage: 'Previous slide.',
        nextSlideMessage: 'Next slide.',
        firstSlideMessage: 'This is the first slide.',
        lasttSlideMessage: 'This is the last slide.'
    },
});

const slider_button = document.getElementById('slider-button');

if (slider_button) {
    let autoplay = swiper.autoplay;
    autoplay.stop();

    slider_button.addEventListener('click', (e) => {
        e.preventDefault();

        if (!autoplay.paused && !autoplay.running) {
            // console.log('Starting autoplay again, both are false');
            autoplay.start();
        } else {
            autoplay.stop();
        }

    });
}

swiper.on('autoplayStop', () => {
    let icon = slider_button.querySelector('i');
    icon.classList = 'fas fa-play';
    icon.dataset.icon = 'play';
    icon.classList.remove('fa-pause');
    icon.classList.add('fa-play');
});

swiper.on('autoplayStart', () => {
    let icon = slider_button.querySelector('i');
    icon.classList = 'fas fa-pause';
    icon.dataset.icon = 'pause';
    icon.classList.remove('fa-play');
    icon.classList.add('fa-pause');
    if ( (swiper.realIndex + 1) == swiper.slides.length ) {
       swiper.slideToLoop();
    } else {
        swiper.slideNext();
    }
});
